(function () {
  class NewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.newsletter-popup__dialog');
      this.dismissEls = this.querySelectorAll('[data-npu-dismiss]');
      this.sectionId = this.dataset.sectionId;
      this.storageKey = 'npu-dismissed-at-' + (this.sectionId || this.id);
      this.reappearDays = parseInt(this.dataset.reappearDays || '7', 10);
      this.delay = parseInt(this.dataset.delay || '4000', 10);

      this.dismissEls.forEach((el) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          this.close(true);
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) {
          this.close(true);
        }
      });

      const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');

      if (isDesignMode) {
        // Only open/close on demand when this section is selected in the
        // theme editor, so it doesn't pop up while editing other sections.
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.sectionId) this.open();
        });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.detail.sectionId === this.sectionId) this.close(false);
        });
        return;
      }

      const hasSuccess = !!this.querySelector('[data-npu-success]');

      if (hasSuccess) {
        // The customer just subscribed (page reloaded after the form post):
        // show the popup right away with the confirmation + code, and reset
        // the "reappear after N days" timer from now.
        this.markDismissed();
        window.setTimeout(() => this.open(), 300);
        return;
      }

      let lastDismissed = 0;
      try {
        lastDismissed = parseInt(window.localStorage.getItem(this.storageKey) || '0', 10);
      } catch (e) {}

      const reappearMs = this.reappearDays * 24 * 60 * 60 * 1000;
      if (lastDismissed && Date.now() - lastDismissed < reappearMs) return;

      window.setTimeout(() => this.open(), this.delay);
    }

    markDismissed() {
      try {
        window.localStorage.setItem(this.storageKey, String(Date.now()));
      } catch (e) {}
    }

    open() {
      this.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      const emailInput = this.querySelector('input[type="email"]');
      if (emailInput) {
        window.setTimeout(() => emailInput.focus({ preventScroll: true }), 100);
      }
    }

    close(remember) {
      this.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (remember) this.markDismissed();
    }
  }

  if (!customElements.get('newsletter-popup')) {
    customElements.define('newsletter-popup', NewsletterPopup);
  }
})();
